const
  NAME                 = 'deactivateTabsOnclick',
  VERSION              = '1.0.0',
  JQUERY_NO_CONFLICT   = $.fn[NAME]
;

class DeactivateTabsOnclick {
  constructor(element$) {
    this._elementAttr$ = element$.data().vocDeactivateTabsOnclick;

    element$.on('click', (e) => this.onClick(e));
  }

  onClick(/*event*/) {
    $(`a[href="#${this._elementAttr$}"]`).parent('li').removeClass('active');
    $(`#${this._elementAttr$}`).removeClass('active');
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new DeactivateTabsOnclick($(this));
    });
  }
}

$.fn[NAME]             = DeactivateTabsOnclick._jQueryInterface;
$.fn[NAME].Constructor = DeactivateTabsOnclick;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return DeactivateTabsOnclick._jQueryInterface;
};

export default DeactivateTabsOnclick;



// WEBPACK FOOTER //
// ./src/plugins/deactivate-tabs-onclick.js